import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { EvidenceModal } from './EvidenceModal';
import { AppData } from '../../types';
import { formatDateTime } from '../../utils/dateFormat';
import { Plus, File, Image, Film, Music } from 'lucide-react';
interface EvidenceTabProps {
  data: AppData;
  onAddEvidence: (evidence: any) => void;
}
export function EvidenceTab({
  data,
  onAddEvidence
}: EvidenceTabProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getIcon = (type: string) => {
    if (type.startsWith('image/')) return <Image className="w-8 h-8 text-blue-500" data-id="element-139" />;
    if (type.startsWith('video/')) return <Film className="w-8 h-8 text-red-500" data-id="element-140" />;
    if (type.startsWith('audio/')) return <Music className="w-8 h-8 text-yellow-500" data-id="element-141" />;
    return <File className="w-8 h-8 text-gray-500" data-id="element-142" />;
  };
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-143">
      <div className="flex justify-between items-center" data-id="element-144">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-145">Evidence Storage</h2>
        <Button onClick={() => setIsModalOpen(true)} leftIcon={<Plus className="w-4 h-4" data-id="element-147" />} data-id="element-146">
          Upload Evidence
        </Button>
      </div>

      {data.evidence.length === 0 ? <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200" data-id="element-148">
          <p className="text-gray-500 mb-4" data-id="element-149">No evidence uploaded yet</p>
          <Button variant="secondary" onClick={() => setIsModalOpen(true)} data-id="element-150">
            Upload Your First Item
          </Button>
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-151">
          {data.evidence.map(item => <Card key={item.id} hover className="flex flex-col" data-id="element-152">
              <div className="flex items-center gap-4 mb-4" data-id="element-153">
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-154">
                  {getIcon(item.fileType)}
                </div>
                <div className="overflow-hidden" data-id="element-155">
                  <h3 className="font-bold text-gray-900 truncate" title={item.fileName} data-id="element-156">
                    {item.fileName}
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-157">
                    {formatDateTime(item.timestamp)}
                  </p>
                </div>
              </div>

              <p className="text-sm text-gray-600 line-clamp-3 mb-4 flex-1" data-id="element-158">
                {item.description || 'No description provided'}
              </p>

              <div className="text-xs text-gray-400 border-t pt-3 mt-auto" data-id="element-159">
                Type: {item.fileType}
              </div>
            </Card>)}
        </div>}

      <EvidenceModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={onAddEvidence} data-id="element-160" />
    </div>;
}